var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "board-container"
  }, [_c('div', {
    staticClass: "board-table board-table--input",
    attrs: {
      "role": "table"
    }
  }, [_c('div', {
    attrs: {
      "role": "rowgroup"
    }
  }, [_c('div', {
    attrs: {
      "role": "row"
    }
  }, [_c('div', {
    staticClass: "w-100",
    attrs: {
      "role": "cell"
    }
  }, [_c('div', {
    staticClass: "form-input"
  }, [_c('select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: false,
      expression: "false"
    }, {
      name: "model",
      rawName: "v-model",
      value: _vm.question.type,
      expression: "question.type"
    }],
    staticClass: "select",
    on: {
      "change": function change($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.question, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("문의유형")]), _vm._l(_vm.questionTypes, function (type, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": type
      }
    }, [_vm._v(_vm._s(type))]);
  })], 2), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.question.subject,
      expression: "question.subject"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "제목"
    },
    domProps: {
      "value": _vm.question.subject
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.question, "subject", $event.target.value);
      }
    }
  })])])]), _c('div', {
    attrs: {
      "role": "row"
    }
  }, [_c('div', {
    staticClass: "w-100",
    attrs: {
      "role": "cell"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.question.content,
      expression: "question.content"
    }],
    staticStyle: {
      "width": "100%",
      "height": "300px",
      "border": "1px solid #ddd"
    },
    domProps: {
      "value": _vm.question.content
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.question, "content", $event.target.value);
      }
    }
  })])])])]), _c('div', {
    staticClass: "button-group"
  }, [_c('v-btn', {
    staticClass: "min-w-120px min-w-lg-200px",
    attrs: {
      "large": "",
      "outlined": "",
      "rounded": "",
      "color": "grey",
      "elevation": "0"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_c('span', {
    staticClass: "color-grey"
  }, [_vm._v("취소")])]), _c('v-btn', {
    staticClass: "min-w-120px min-w-lg-200px",
    attrs: {
      "large": "",
      "rounded": "",
      "color": "primary",
      "elevation": "0"
    },
    on: {
      "click": _vm.save
    }
  }, [_c('span', [_vm._v("확인")])])], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }